import React, { useState, useEffect } from "react";
import ExpandedChipProps from "./ExpandedChipProps";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { Chip, Box } from "@mui/material";
import { SxProps } from "@mui/system";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import greenDot from "../../assets/images/green-dot2.png";
import redDot from "../../assets/images/red-dot.png";
import { isEnterPress } from "../../utils/helpers/accessibilityUtil";

const statusIcons = [greenDot, redDot];

const ExpandedChip = (props: ExpandedChipProps) => {
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState(props.label);



  useEffect(() => {
    setLabel(props.label);
  }, [props.label]);

  const handleClick = (clickedLabel?: string) => {
    if (clickedLabel !== null && clickedLabel) {
      setLabel(clickedLabel);
      props.setCurrentLabel && props.setCurrentLabel(clickedLabel);
    }
    if (props.handleChipClick && props.index) {
      props.handleChipClick(props.index);
    }
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const GenerateIcon = () => {
    if (props.iconLabel === "ArrowDown") {
      if (open) {
        return <KeyboardArrowUpIcon fontSize="small" />;
      }
      return <KeyboardArrowDownIcon fontSize="small" />;
    } else if (props.iconLabel === "arrowLeft") {
      return <ArrowBackIcon fontSize="small" />;
    }
  };

  const styles: SxProps = {
    position: "absolute",
    top: 50,
    right: `${props.boxRight ? props.boxRight : "-10px"}`,
    left: `${props.boxLeft ? props.boxLeft : 0}`,
    zIndex: 1,
    bgcolor: "#3F4244",
    width: `${props.boxWidth ? props.boxWidth : "145px"}`,
    // height: "440px",
    borderRadius: "20px",
  };

  return (
    <div aria-label={props.ariaLabel}>
      <ClickAwayListener onClickAway={handleClickAway} /*key={index}*/>
        <Box id={`ExpandedChip-${props.index}`} sx={{ position: "relative" }}>
          <Chip
            onClick={() => handleClick(label)}
            // key={index}
            label={label}
            aria-label={label}
            icon={GenerateIcon()}
            sx={{
              fontFamily: "Assistant",
              fontSize: "18px",
              borderRadius: "32px",
              height: "40px",
              cursor: "pointer",
              marginRight: "16px",
              flexDirection: "row-reverse",
              background: `${props.bgColor ? props.bgColor : "#f5f7f9)"}`,
              "&:hover": {
                background: `${props.bgColor ? props.bgColor : "#e7ebf"}`,
              },
            }}
          />
          {open && props.labels ? (
            <Box sx={styles}>
              {props.customDesign
                ? props.labels.map((label: string, index: number) =>
                    !index ? (
                      <div
                        className="chips-more-years-label more-years-custom-design"
                        key={index}
                        onClick={() => handleClick(label)}
                        onKeyPress={(event) =>
                          isEnterPress(event) && handleClick(label)
                        }
                        tabIndex={0}
                      >
                        {label}
                      </div>
                    ) : (
                      <div
                        className="chips-more-years-label more-years-custom-design"
                        key={index}
                        onClick={() => handleClick(label)}
                        onKeyPress={(event) =>
                          isEnterPress(event) && handleClick(label)
                        }
                        tabIndex={0}
                      >
                        <img src={statusIcons[index - 1]} alt="icon" />
                        <span style={{ marginRight: "10px" }}>{label}</span>
                      </div>
                    )
                  )
                : props.labels.map((label: string, index: number) => (
                    <div
                      className="chips-more-years-label"
                      key={index}
                      onClick={() => handleClick(label)}
                      onKeyPress={(event) =>
                        isEnterPress(event) && handleClick(label)
                      }
                      tabIndex={0}
                    >
                      {label}
                    </div>
                  ))}
            </Box>
          ) : null}
        </Box>
      </ClickAwayListener>
    </div>
  );
};

export default ExpandedChip;
